import {useMutation} from '@tanstack/react-query';
import {MUTATION_KEYS} from 'infra/libs/react-query/mutationKeys';
import {postB2BBeneficiaryAuthorization} from 'presentation/services/postB2BBeneficiaryAuthorization';

export const usePostB2BBeneficiaryAuthorizationMutation = () =>
	useMutation({
		mutationKey: [MUTATION_KEYS.B2B_BENEFICIARY_AUTHORIZATION],
		mutationFn: postB2BBeneficiaryAuthorization,
	});
